var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
__name(_extends, "_extends");
import React from "react";
import Icon from "@ant-design/icons";
var WishlistSvg = /* @__PURE__ */ __name(function WishlistSvg2() {
  return /* @__PURE__ */ React.createElement("svg", {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "32",
    height: "32",
    viewBox: "0 0 32 32"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M16 30.618l-0.991-1.067c-0.444-0.48-0.889-0.947-1.333-1.409s-0.827-0.889-1.231-1.298l-0.231-0.244c-5.809-6.12-10.4-10.951-10.4-16.187 0-5.587 4.062-8.511 8.076-8.511 2.711 0 4.889 2.142 6.111 3.747 1.24-1.596 3.404-3.733 6.12-3.733 5.244 0 8.071 4.378 8.071 8.498 0 5.218-4.662 10.133-10.56 16.356l-0.076 0.084-1.302 1.369-1.271 1.333zM9.889 4.124c-2.818 0-5.853 1.969-5.853 6.289s4.32 8.889 9.778 14.667l0.249 0.253c0.404 0.444 0.813 0.858 1.222 1.293l0.716 0.738 0.636-0.671 1.382-1.444c5.538-5.876 9.951-10.507 9.951-14.836 0-4.12-2.942-6.276-5.849-6.276-1.996 0-4 2.089-5.169 4.040l-0.951 1.56-0.951-1.56c-1.187-1.956-3.169-4.053-5.16-4.053z"
  }));
}, "WishlistSvg");
var WishlistIcon = /* @__PURE__ */ __name(function WishlistIcon2(props) {
  return /* @__PURE__ */ React.createElement(Icon, _extends({
    component: WishlistSvg
  }, props));
}, "WishlistIcon");
export {
  WishlistIcon
};
